// @ts-nocheck
import _ from 'lodash';
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../configs';
import { toastTypes } from '../enums';
import getRoot from './root';
import useEmailManagementStore from './emailManagement';

const useEmailSuppressionStore = create((set) => ({
  unsubscribesList: [],
  loading: false,

  reset: () => set({ loading: false, unsubscribesList: [] }),

  uploadCSV: async (files) => {
    const root = getRoot();
    if (!files || files.length === 0) {
      root.failure('No file selected.', toastTypes.uploadCSV);
      return;
    }
    set({ loading: true });
    try {
      const formData = new FormData();
      formData.append('file', files[0]);
      const token = await root.firebase.auth().currentUser.getIdToken();
      const { data } = await axios.post(`${API_URL}/api/em/do-not-mail`, formData, {
        headers: {
          Authorization: token,
          EmailDomain: useEmailManagementStore.getState().activeEmailDomainName,
        },
      });
      if (_.get(data, 'success')) {
        const total = _.get(data, 'data.totalEmailsSuppressionCount');
        root.success(`Added ${total} emails to unsubscribes list.`, toastTypes.uploadCSV);
        root.clearToast(toastTypes.uploadCSV);
      } else {
        root.failure('Something went wrong, please check your files again.', toastTypes.uploadCSV);
      }
    } catch (err) {
      root.failure('Error uploading CSV.', toastTypes.uploadCSV);
    } finally {
      set({ loading: false });
    }
  },

  addEmail: async (hook) => {
    const root = getRoot();
    try {
      const res = await axios.post(`${API_URL}/api/em/do-not-one-mail/`, {
        emailDomain: hook.emailDomain,
        email: hook.email,
      }, {
        headers: {
          Authorization: await root.firebase.auth().currentUser.getIdToken(),
          EmailDomain: useEmailManagementStore.getState().activeEmailDomainName,
        },
      });
      if (res.data.success) {
        root.success('Email added successfully!', toastTypes.addEmail);
        root.clearToast(toastTypes.addEmail);
      } else {
        root.failure('Failed to add a email.', toastTypes.addEmail);
      }
    } catch (e) {
      root.failure('Failed to add a email.', toastTypes.addEmail);
    }
  },

  deleteEmail: async (hookId) => {
    const root = getRoot();
    try {
      const res = await axios.delete(`${API_URL}/api/clientHooks/${hookId}`);
      if (res.data.success) {
        root.success('Email deleted successfully!', toastTypes.deleteEmail);
        root.clearToast(toastTypes.deleteEmail);
      } else {
        root.failure('Failed to delete email.', toastTypes.deleteEmail);
      }
    } catch (e) {
      root.failure('Failed to delete email.', toastTypes.deleteEmail);
    }
  },
}));

export default useEmailSuppressionStore;
